import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {initFlowbite} from 'flowbite';
import {animate, keyframes, state, style, transition, trigger} from "@angular/animations";
import {SessionService} from "../services/session.service";
import {MessengerService} from "../services/messenger.service";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-chat-widget',
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.css'],
  animations: [
    trigger('fadeOut', [
      state('void', style({opacity: 0})), // Estilo cuando el elemento desaparece
      transition(':leave', [animate('0.5s ease-out')]), // Animación para desaparecer
    ]),
    trigger('fadeIn', [
      state('void', style({opacity: 0})), // Estilo inicial cuando el elemento no está en el DOM
      transition(':enter', [animate('0.5s ease-in')]), // Animación para aparecer
    ]),
    trigger('flapInOut', [
      // FlapIn (Entrada)
      transition(':enter', [
        animate(
          '0.6s ease-out',
          keyframes([
            style({transform: 'rotateY(90deg)', opacity: 0, offset: 0}),
            style({transform: 'rotateY(20deg)', opacity: 0.8, offset: 0.7}),
            style({transform: 'rotateY(0deg)', opacity: 1, offset: 1}),
          ])
        ),
      ]),
      // FlapOut (Salida)
      transition(':leave', [
        animate(
          '0.6s ease-in',
          keyframes([
            style({transform: 'rotateY(0deg)', opacity: 1, offset: 0}),
            style({transform: 'rotateY(70deg)', opacity: 0.5, offset: 0.3}),
            style({transform: 'rotateY(90deg)', opacity: 0, offset: 1}),
          ])
        ),
      ]),
    ]),
  ],
})
export class ChatWidgetComponent implements OnInit {
  @ViewChild('scrollable') scrollable: ElementRef | undefined;
  sessionId: string | undefined;
  isChatVisible = false;
  isWriting = false;
  userMessage = '';
  messages: any = [
    {
      code: null,
      name: 'Tu',
      actor: 'user',
      body: 'Hola'
    }
  ];
  baseUrl = environment.frontUrl
  /*
  *
  * Horarios de atención
Medios de acceso
Crear cuenta ciudad
Recargar cuenta
Tarifas vigentes
Normas de uso
  * */
  fastMessagesList: any = [
    {title: 'Conoce sobre Cultura Metro', message: 'Quiero conocer sobre Cultura Metro'},
    {title: 'Tienes una sugerencia o queja del servicio', message: 'Tienes una sugerencia o queja del servicio'},
    {title: 'Conoce los horarios de atención', message: 'Conoce los horarios de atención'},
    {title: 'Conoce los medios de pago y recarga', message: 'Conoce los medios de pago y recarga'},
    {title: 'Perdiste un objeto en el Metro de Quito', message: 'Perdiste un objeto en el Metro de Quito'}
  ];

  constructor(
    private sessionService: SessionService,
    private messengerService: MessengerService,
  ) {

  }

  ngOnInit(): void {
    initFlowbite()
    this.sessionId = this.sessionService.getSessionData()
    this.loadHistory()
  }

  loadHistory(){
    this.messages = this.sessionService.chatGetMessages()
    this.scrollToBottom()
  }

  scrollToBottom(): void {
    try {
      setTimeout(() => {
        let objDiv: any = document.getElementById("chat-messages");
        if (objDiv)
          objDiv.scrollTop = objDiv?.scrollHeight;

        const inputObj: any = document.getElementById("txtMessage");
        inputObj?.focus()
      }, 100)
    } catch (err) {
    }
  }

  toggleChat() {
    this.isChatVisible = !this.isChatVisible;
    this.scrollToBottom()
    if (this.isChatVisible) {
      window.parent.postMessage({type: 'resize', width: '39rem', height: '50rem'}, '*');
    } else {
      window.parent.postMessage({type: 'resize', width: '15rem', height: '12rem'}, '*');
    }
  }

  sendMessage(instantMessage?: string) {
    let textMessage = instantMessage?.trim() || this.userMessage.trim()
    if (textMessage) {
      this.isWriting = true;
      // Agregar mensaje del usuario
      const message = {
        code: null,
        name: 'Tu',
        actor: 'user',
        body: textMessage
      }
      this.messages.push(message);
      this.sessionService.chatSaveMessage(message)

      this.scrollToBottom();
      this.messengerService.sendMessageIAConversation({
        application: {code: '89a0935a-5453-4938-8571-999AS89DA890'},
        conversation: {
          sessionId: this.sessionId,
        },
        message: {
          body: textMessage
        }
      }).subscribe({
        next: (data: any) => {
          this.userMessage = '';
          data.name ='Gallito'
          this.sessionService.chatSaveMessage(data)
          this.messages.push(data);
          this.scrollToBottom();
          this.isWriting = false;

        },error: ()=>{
          this.isWriting = false;
          const message ={
            code: null,
            name: '',
            actor: 'assistant',
            body: 'Lo siento no puden entender tu mensaje.'
          }
          this.messages.push();
          this.sessionService.chatSaveMessage(message)
        }
      })
    }
  }
}
